module.exports = __webpack_public_path__ + "img/icon_map_2_on_001.8cf1cbe7.png";